// "Websites to check out" — part of the HELPFUL WEBSITES AND APPS section.
// Website cards: logo + linked URL as the title + a short description.
import { weblink, pdf2026 } from "./assets";

const websitesCards = [
  {
    title: "Plant-Based Mavens",
    href: "https://www.plantbasedmavens.com",
    linkText: "www.plantbasedmavens.com",
    img: weblink("_0004_Plant-Based Mavens logo.jpg"),
    description: "Plant-based nutrition for women",
  },
  {
    title: "Forks Over Knives",
    href: "https://www.forksoverknives.com",
    linkText: "www.forksoverknives.com",
    img: weblink("_0000_Forks over Knives logo.jpg"),
    description: "The healthy whole-food lifestyle magazine.",
  },
  {
    title: "Center for Plant-Based Living",
    href: "https://www.plantbasedcenter.com",
    linkText: "www.plantbasedcenter.com",
    img: weblink("_0002_Ceter for Plant-Based Living type.jpg"),
    description: "Simplifying plant-based living with science, flavor and heart.",
  },
  {
    title: "Whole Food Plant-Based Recipes",
    href: pdf2026("Websites Apps", "Whole-Food-Plant-Based-Cookbook-Lifestyle-Medicine.pdf"),
    linkText: "Whole-Food-Plant-Based-Cookbook-Lifestyle-Medicine.pdf (kaiserpermanente.org)",
    img: weblink("_0001_Whole Food Plant-Based Recipes graphic.jpg"),
    description: "Dozens of easy and delicious whole-food, plant-based recipes.",
  },
  {
    // TODO: confirm exact PlantYou destination URL (design shows an article title,
    // not a URL). Linked to the PlantYou site root for now.
    title: "PlantYou",
    href: "https://plantyou.com/",
    linkText: "Five Minute Plant-Based Meals (Easy & Healthy!) - PlantYou",
    img: weblink("_0003_Plant You logo.jpg"),
    description: "Healthy plant-based meals you can make in less than five minutes!",
  },
  {
    title: "Blue Zones",
    href: "https://www.bluezones.com/recipes/",
    linkText: "www.bluezones.com/recipes/",
    img: weblink("_0005_Bluezone logo.jpg"),
    description:
      "Healthy recipes that take less than 30 minutes to assemble and follow the Blue Zone Guidelines for longevity.",
  },
];

export default websitesCards;
